import { render, staticRenderFns } from "./corneaNPJ.vue?vue&type=template&id=cad7cf92&scoped=true&"
import script from "./corneaNPJ.vue?vue&type=script&lang=js&"
export * from "./corneaNPJ.vue?vue&type=script&lang=js&"
import style0 from "./corneaNPJ.vue?vue&type=style&index=0&id=cad7cf92&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cad7cf92",
  null
  
)

export default component.exports